import React from 'react';
import { CallToAction, Surface } from '@americanexpress/dls-react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { formatDate } from '../../../utils/abandonCartUtils';
import { postContextFeedbackThunk } from '../../../thunks/postContextFeedbackThunk';
import { getHotelDeepLinksUrl } from '../../../selectors/getContextApiSelectors';
import { useAbandonCartData } from '../../../hooks/useContextApiHook';
import { useAccountToken } from '../../../hooks/useMembershipDataHook';

const ContinueButton = ({ triggerAnalytics, buttonTextLocaleId }) => {
  const dispatch = useDispatch();
  const accountToken = useAccountToken();
  const { formatMessage } = useIntl();
  const {
    data: abandonCartData,
  } = useAbandonCartData();
  const {
    tripStartDate,
    tripEndDate,
    hotelProductSelected,
    hotelRoomType,
    hotelId,
  } = abandonCartData;

  const hotelDetailDeepLink = useSelector(getHotelDeepLinksUrl({
    hotelId,
    tripStartDate,
    tripEndDate,
    hotelRoomType,
  }));

  return (
    <Surface variant="fg-subtle" className="bg-none">
      <CallToAction
        id="abandonHotelContinueButton"
        aria-describedby={
        `${formatMessage({ id: 'abandonHotel.finish' })} ${hotelProductSelected} ${formatDate(tripStartDate)} - ${formatDate(tripEndDate)}`
      }
        href={hotelDetailDeepLink}
        target="_blank"
        inline={true}
        rel="noopener noreferrer"
        variant="secondary"
        className="flex-align-items-center"
        onClick={(event) => {
          event.stopPropagation();
          triggerAnalytics('continue');
          dispatch(postContextFeedbackThunk({ abandonCartData, accountToken }));
        }}
      >
        {formatMessage({ id: buttonTextLocaleId })}
      </CallToAction>
    </Surface>
  );
};

ContinueButton.propTypes = {
  triggerAnalytics: PropTypes.func.isRequired,
  buttonTextLocaleId: PropTypes.string.isRequired,
};

export default ContinueButton;
